import {
  Hotel,
  FeaturedDestination,
  TourPackage,
  Review,
  BlogPost,
} from "../types";

export const featuredDestinations: FeaturedDestination[] = [
  {
    id: "1",
    name: "Cairo",
    country: "Egypt",
    image:
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=400&h=300&fit=crop",
    hotelCount: 156,
    averagePrice: 85,
  },
  {
    id: "2",
    name: "Luxor",
    country: "Egypt",
    image:
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=300&fit=crop",
    hotelCount: 42,
    averagePrice: 65,
  },
  {
    id: "3",
    name: "Aswan",
    country: "Egypt",
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
    hotelCount: 28,
    averagePrice: 55,
  },
  {
    id: "4",
    name: "Sharm El Sheikh",
    country: "Egypt",
    image:
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    hotelCount: 89,
    averagePrice: 120,
  },
  {
    id: "5",
    name: "Amman",
    country: "Jordan",
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
    hotelCount: 67,
    averagePrice: 95,
  },
  {
    id: "6",
    name: "Petra",
    country: "Jordan",
    image:
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=300&fit=crop",
    hotelCount: 23,
    averagePrice: 75,
  },
  {
    id: "7",
    name: "Dubai",
    country: "UAE",
    image:
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    hotelCount: 234,
    averagePrice: 180,
  },
  {
    id: "8",
    name: "Istanbul",
    country: "Turkey",
    image:
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=400&h=300&fit=crop",
    hotelCount: 189,
    averagePrice: 110,
  },
  {
    id: "9",
    name: "Marrakech",
    country: "Morocco",
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
    hotelCount: 78,
    averagePrice: 85,
  },
  {
    id: "10",
    name: "Jerusalem",
    country: "Palestine",
    image:
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=300&fit=crop",
    hotelCount: 45,
    averagePrice: 90,
  },
];

export const mockHotels: Hotel[] = [
  {
    id: "1",
    name: "Nile Palace Hotel",
    location: "Corniche El Nil, Cairo",
    city: "Cairo",
    country: "Egypt",
    stars: 5,
    rating: 4.8,
    reviewCount: 1247,
    price: 180,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Pool",
      "Spa",
      "Restaurant",
      "Fitness Center",
      "Airport Shuttle",
    ],
    description:
      "Luxurious 5-star hotel overlooking the Nile River with world-class amenities and exceptional service.",
    coordinates: { lat: 30.0444, lng: 31.2357 },
    rooms: [
      {
        id: "r1",
        type: "Deluxe Nile View",
        bedType: "King Bed",
        maxOccupancy: 2,
        price: 180,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: ["Nile View", "Balcony", "Mini Bar", "Room Service"],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
      {
        id: "r2",
        type: "Executive Suite",
        bedType: "King Bed",
        maxOccupancy: 3,
        price: 320,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 48 hours before check-in",
        amenities: [
          "Nile View",
          "Separate Living Area",
          "Mini Bar",
          "Butler Service",
        ],
        images: [
          "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "2",
    name: "Luxor Temple Resort",
    location: "Karnak Temple Road, Luxor",
    city: "Luxor",
    country: "Egypt",
    stars: 4,
    rating: 4.6,
    reviewCount: 892,
    price: 95,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
    ],
    amenities: ["Free WiFi", "Pool", "Restaurant", "Garden", "Tour Desk"],
    description:
      "Charming resort near the ancient temples with traditional Egyptian architecture and modern comforts.",
    coordinates: { lat: 25.6872, lng: 32.6396 },
    rooms: [
      {
        id: "r3",
        type: "Standard Room",
        bedType: "Twin Beds",
        maxOccupancy: 2,
        price: 95,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: ["Garden View", "Air Conditioning", "Private Bathroom"],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "3",
    name: "Aswan Nubian Lodge",
    location: "Elephantine Island, Aswan",
    city: "Aswan",
    country: "Egypt",
    stars: 3,
    rating: 4.4,
    reviewCount: 456,
    price: 65,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Restaurant",
      "Garden",
      "Nile View",
      "Cultural Activities",
    ],
    description:
      "Authentic Nubian experience on Elephantine Island with traditional architecture and local hospitality.",
    coordinates: { lat: 24.0889, lng: 32.8998 },
    rooms: [
      {
        id: "r4",
        type: "Nubian Style Room",
        bedType: "Double Bed",
        maxOccupancy: 2,
        price: 65,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: ["Nile View", "Traditional Decor", "Private Bathroom"],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "4",
    name: "Red Sea Paradise Resort",
    location: "Naama Bay, Sharm El Sheikh",
    city: "Sharm El Sheikh",
    country: "Egypt",
    stars: 5,
    rating: 4.9,
    reviewCount: 2156,
    price: 220,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Private Beach",
      "Pool",
      "Spa",
      "Restaurant",
      "Diving Center",
      "Kids Club",
    ],
    description:
      "Exclusive beachfront resort with pristine Red Sea views and world-class diving facilities.",
    coordinates: { lat: 27.9158, lng: 34.33 },
    rooms: [
      {
        id: "r5",
        type: "Beachfront Villa",
        bedType: "King Bed",
        maxOccupancy: 4,
        price: 220,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 48 hours before check-in",
        amenities: [
          "Beach Access",
          "Private Terrace",
          "Mini Bar",
          "Room Service",
        ],
        images: [
          "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "5",
    name: "Grand Hyatt Cairo",
    location: "Corniche El Nil, Garden City, Cairo",
    city: "Cairo",
    country: "Egypt",
    stars: 5,
    rating: 4.7,
    reviewCount: 1834,
    price: 250,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Pool",
      "Spa",
      "Multiple Restaurants",
      "Fitness Center",
      "Business Center",
      "Concierge",
      "Valet Parking",
    ],
    description:
      "World-class luxury hotel in the heart of Cairo with stunning Nile views and exceptional service.",
    coordinates: { lat: 30.0444, lng: 31.2357 },
    rooms: [
      {
        id: "r6",
        type: "Grand Nile View Room",
        bedType: "King Bed",
        maxOccupancy: 2,
        price: 250,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: ["Nile View", "City View", "Mini Bar", "Room Service"],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "6",
    name: "Hilton Luxor Resort & Spa",
    location: "Karnak, Luxor",
    city: "Luxor",
    country: "Egypt",
    stars: 5,
    rating: 4.5,
    reviewCount: 967,
    price: 140,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Pool",
      "Spa",
      "Restaurant",
      "Fitness Center",
      "Tennis Court",
      "Kids Club",
      "Tour Desk",
    ],
    description:
      "Luxurious resort with direct access to the Nile and close proximity to ancient temples.",
    coordinates: { lat: 25.6872, lng: 32.6396 },
    rooms: [
      {
        id: "r7",
        type: "Nile View Room",
        bedType: "King Bed",
        maxOccupancy: 2,
        price: 140,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: [
          "Nile View",
          "Balcony",
          "Air Conditioning",
          "Private Bathroom",
        ],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "7",
    name: "Sofitel Legend Old Cataract",
    location: "Abtal El Tahrir Street, Aswan",
    city: "Aswan",
    country: "Egypt",
    stars: 5,
    rating: 4.8,
    reviewCount: 1234,
    price: 300,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Pool",
      "Spa",
      "Multiple Restaurants",
      "Fitness Center",
      "Tennis Court",
      "Library",
      "Historic Building",
    ],
    description:
      "Historic luxury hotel where Agatha Christie wrote 'Death on the Nile' with breathtaking Nile views.",
    coordinates: { lat: 24.0889, lng: 32.8998 },
    rooms: [
      {
        id: "r8",
        type: "Historic Nile View Suite",
        bedType: "King Bed",
        maxOccupancy: 2,
        price: 300,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 48 hours before check-in",
        amenities: [
          "Nile View",
          "Historic Decor",
          "Butler Service",
          "Mini Bar",
        ],
        images: [
          "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "8",
    name: "Four Seasons Resort Sharm El Sheikh",
    location: "Sharm El Sheikh, South Sinai",
    city: "Sharm El Sheikh",
    country: "Egypt",
    stars: 5,
    rating: 4.9,
    reviewCount: 2156,
    price: 350,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Private Beach",
      "Multiple Pools",
      "Spa",
      "Multiple Restaurants",
      "Fitness Center",
      "Diving Center",
      "Kids Club",
      "Tennis Court",
    ],
    description:
      "Ultimate luxury beachfront resort with pristine Red Sea access and world-class facilities.",
    coordinates: { lat: 27.9158, lng: 34.33 },
    rooms: [
      {
        id: "r9",
        type: "Beachfront Suite",
        bedType: "King Bed",
        maxOccupancy: 3,
        price: 350,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 48 hours before check-in",
        amenities: [
          "Beach Access",
          "Private Terrace",
          "Mini Bar",
          "Butler Service",
          "Room Service",
        ],
        images: [
          "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "9",
    name: "Marriott Mena House",
    location: "6 Pyramids Road, Giza",
    city: "Giza",
    country: "Egypt",
    stars: 5,
    rating: 4.6,
    reviewCount: 1456,
    price: 200,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Pool",
      "Spa",
      "Restaurant",
      "Fitness Center",
      "Tennis Court",
      "Golf Course",
      "Pyramid View",
    ],
    description:
      "Historic hotel with direct views of the Great Pyramids, offering an unforgettable Egyptian experience.",
    coordinates: { lat: 30.0131, lng: 31.2089 },
    rooms: [
      {
        id: "r10",
        type: "Pyramid View Room",
        bedType: "King Bed",
        maxOccupancy: 2,
        price: 200,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: [
          "Pyramid View",
          "Balcony",
          "Air Conditioning",
          "Private Bathroom",
        ],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "10",
    name: "Steigenberger Hotel El Tahrir",
    location: "Tahrir Square, Cairo",
    city: "Cairo",
    country: "Egypt",
    stars: 4,
    rating: 4.3,
    reviewCount: 789,
    price: 120,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Pool",
      "Restaurant",
      "Fitness Center",
      "Business Center",
      "City Center Location",
    ],
    description:
      "Modern hotel in the heart of downtown Cairo, perfect for business and leisure travelers.",
    coordinates: { lat: 30.0444, lng: 31.2357 },
    rooms: [
      {
        id: "r11",
        type: "Deluxe City View",
        bedType: "King Bed",
        maxOccupancy: 2,
        price: 120,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: [
          "City View",
          "Air Conditioning",
          "Private Bathroom",
          "Work Desk",
        ],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "11",
    name: "Hurghada Marriott Beach Resort",
    location: "Hurghada, Red Sea",
    city: "Hurghada",
    country: "Egypt",
    stars: 5,
    rating: 4.4,
    reviewCount: 1123,
    price: 180,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Private Beach",
      "Pool",
      "Spa",
      "Restaurant",
      "Fitness Center",
      "Diving Center",
      "Kids Club",
      "Water Sports",
    ],
    description:
      "All-inclusive beachfront resort with crystal-clear Red Sea waters and excellent diving opportunities.",
    coordinates: { lat: 27.2574, lng: 33.8129 },
    rooms: [
      {
        id: "r12",
        type: "Sea View Room",
        bedType: "King Bed",
        maxOccupancy: 2,
        price: 180,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: [
          "Sea View",
          "Balcony",
          "Air Conditioning",
          "Private Bathroom",
        ],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
  {
    id: "12",
    name: "Budget Inn Alexandria",
    location: "Corniche Road, Alexandria",
    city: "Alexandria",
    country: "Egypt",
    stars: 2,
    rating: 3.8,
    reviewCount: 234,
    price: 45,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop",
    ],
    amenities: [
      "Free WiFi",
      "Restaurant",
      "City Center Location",
      "Basic Amenities",
    ],
    description:
      "Affordable accommodation in the heart of Alexandria, perfect for budget-conscious travelers.",
    coordinates: { lat: 31.2001, lng: 29.9187 },
    rooms: [
      {
        id: "r13",
        type: "Standard Room",
        bedType: "Twin Beds",
        maxOccupancy: 2,
        price: 45,
        currency: "USD",
        cancellationPolicy: "Free cancellation until 24 hours before check-in",
        amenities: ["Air Conditioning", "Private Bathroom", "Basic Amenities"],
        images: [
          "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop",
        ],
        available: true,
      },
    ],
  },
];

export const mockTourPackages: TourPackage[] = [
  {
    id: "t1",
    title: "Classic Egypt Adventure",
    description:
      "Discover the wonders of ancient Egypt with this comprehensive 8-day tour covering Cairo, Luxor, and Aswan.",
    duration: 8,
    price: 1200,
    currency: "USD",
    image:
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
    ],
    destinations: ["Cairo", "Luxor", "Aswan"],
    highlights: [
      "Great Pyramids of Giza",
      "Valley of the Kings",
      "Karnak Temple",
      "Abu Simbel Temples",
      "Nile River Cruise",
    ],
    includes: [
      "All accommodation",
      "Professional guide",
      "All meals",
      "Entrance fees",
      "Transportation",
      "Nile cruise",
    ],
    excludes: [
      "International flights",
      "Personal expenses",
      "Tips",
      "Travel insurance",
    ],
    difficulty: "Easy",
    groupSize: { min: 2, max: 16 },
    rating: 4.8,
    reviewCount: 156,
    available: true,
    startDate: "2024-03-15",
    endDate: "2024-03-22",
  },
  {
    id: "t2",
    title: "Red Sea Diving Expedition",
    description:
      "Explore the underwater wonders of the Red Sea with world-class diving experiences.",
    duration: 5,
    price: 800,
    currency: "USD",
    image:
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop",
    ],
    destinations: ["Sharm El Sheikh", "Hurghada"],
    highlights: [
      "Coral reef diving",
      "Shipwreck exploration",
      "Marine life encounters",
      "Professional diving instruction",
      "Equipment included",
    ],
    includes: [
      "Diving equipment",
      "Professional instructor",
      "Accommodation",
      "All meals",
      "Transportation",
    ],
    excludes: [
      "International flights",
      "Diving certification",
      "Personal expenses",
      "Travel insurance",
    ],
    difficulty: "Moderate",
    groupSize: { min: 4, max: 12 },
    rating: 4.9,
    reviewCount: 89,
    available: true,
    startDate: "2024-04-10",
    endDate: "2024-04-14",
  },
  {
    id: "t3",
    title: "Jordan & Egypt Combo",
    description:
      "Experience the best of both Jordan and Egypt in this 10-day cultural journey.",
    duration: 10,
    price: 1800,
    currency: "USD",
    image:
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=800&h=600&fit=crop",
    ],
    destinations: ["Amman", "Petra", "Cairo", "Luxor"],
    highlights: [
      "Petra - The Rose City",
      "Wadi Rum Desert",
      "Great Pyramids",
      "Valley of the Kings",
      "Dead Sea experience",
    ],
    includes: [
      "All accommodation",
      "Professional guide",
      "All meals",
      "Entrance fees",
      "Transportation",
      "Desert camp experience",
    ],
    excludes: [
      "International flights",
      "Personal expenses",
      "Tips",
      "Travel insurance",
    ],
    difficulty: "Moderate",
    groupSize: { min: 2, max: 20 },
    rating: 4.7,
    reviewCount: 234,
    available: true,
    startDate: "2024-05-01",
    endDate: "2024-05-10",
  },
  {
    id: "t4",
    title: "Luxury Nile Cruise",
    description:
      "Experience Egypt in ultimate luxury aboard a 5-star Nile cruise ship.",
    duration: 7,
    price: 2500,
    currency: "USD",
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
    ],
    destinations: ["Luxor", "Edfu", "Kom Ombo", "Aswan"],
    highlights: [
      "Luxury cruise ship",
      "Private butler service",
      "Gourmet dining",
      "Spa treatments",
      "Private temple visits",
    ],
    includes: [
      "Luxury cruise accommodation",
      "All meals and beverages",
      "Private guide",
      "Spa treatments",
      "All excursions",
      "Butler service",
    ],
    excludes: [
      "International flights",
      "Personal expenses",
      "Tips",
      "Travel insurance",
    ],
    difficulty: "Easy",
    groupSize: { min: 2, max: 8 },
    rating: 4.9,
    reviewCount: 67,
    available: true,
    startDate: "2024-06-15",
    endDate: "2024-06-21",
  },
];

export const mockReviews: Review[] = [
  {
    id: "r1",
    author: "Sarah Johnson",
    rating: 5,
    title: "Absolutely Amazing Experience!",
    content:
      "The Classic Egypt Adventure tour exceeded all our expectations. Our guide was incredibly knowledgeable and the sites were breathtaking. Highly recommend!",
    date: "2024-01-15",
    verified: true,
    helpful: 23,
    tourId: "t1",
  },
  {
    id: "r2",
    author: "Michael Chen",
    rating: 4,
    title: "Great Hotel with Excellent Service",
    content:
      "The Nile Palace Hotel provided exceptional service and the Nile view was spectacular. The staff went above and beyond to make our stay memorable.",
    date: "2024-01-10",
    verified: true,
    helpful: 18,
    hotelId: "1",
  },
  {
    id: "r3",
    author: "Emma Williams",
    rating: 5,
    title: "Best Diving Experience Ever!",
    content:
      "The Red Sea diving expedition was incredible. The coral reefs were pristine and our instructor was professional and patient. Will definitely book again!",
    date: "2024-01-08",
    verified: true,
    helpful: 31,
    tourId: "t2",
  },
  {
    id: "r4",
    author: "David Rodriguez",
    rating: 4,
    title: "Luxury at its Finest",
    content:
      "The Four Seasons Resort in Sharm El Sheikh was absolutely luxurious. The beach was pristine and the service was impeccable. Worth every penny!",
    date: "2024-01-05",
    verified: true,
    helpful: 15,
    hotelId: "8",
  },
  {
    id: "r5",
    author: "Lisa Thompson",
    rating: 5,
    title: "Perfect Cultural Journey",
    content:
      "The Jordan & Egypt combo tour was perfectly organized. We saw so many incredible sites and learned so much about the history. Our guide was fantastic!",
    date: "2024-01-03",
    verified: true,
    helpful: 27,
    tourId: "t3",
  },
  {
    id: "r6",
    author: "James Wilson",
    rating: 4,
    title: "Historic and Beautiful",
    content:
      "The Sofitel Legend Old Cataract was a perfect blend of history and luxury. The Nile views were stunning and the historic atmosphere was magical.",
    date: "2024-01-01",
    verified: true,
    helpful: 12,
    hotelId: "7",
  },
];

export const mockBlogPosts: BlogPost[] = [
  {
    id: "b1",
    title: "10 Must-See Ancient Egyptian Sites",
    excerpt:
      "Discover the most incredible ancient Egyptian monuments and temples that every traveler should visit.",
    content:
      "Egypt is home to some of the world's most magnificent ancient monuments...",
    author: "Dr. Ahmed Hassan",
    publishDate: "2024-01-20",
    image:
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=800&h=600&fit=crop",
    tags: ["Egypt", "History", "Archaeology", "Travel Tips"],
    readTime: 8,
    featured: true,
  },
  {
    id: "b2",
    title: "The Ultimate Guide to Red Sea Diving",
    excerpt:
      "Everything you need to know about diving in the Red Sea, from beginner tips to advanced techniques.",
    content: "The Red Sea is one of the world's premier diving destinations...",
    author: "Marine Biologist Sarah",
    publishDate: "2024-01-18",
    image:
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&h=600&fit=crop",
    tags: ["Diving", "Red Sea", "Marine Life", "Adventure"],
    readTime: 12,
    featured: true,
  },
  {
    id: "b3",
    title: "Luxury Nile Cruise: What to Expect",
    excerpt:
      "A comprehensive guide to luxury Nile cruises, including what's included and what to pack.",
    content: "A luxury Nile cruise is the ultimate way to experience Egypt...",
    author: "Travel Expert Maria",
    publishDate: "2024-01-15",
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
    tags: ["Nile Cruise", "Luxury Travel", "Egypt", "River Cruises"],
    readTime: 10,
    featured: false,
  },
  {
    id: "b4",
    title: "Jordan's Hidden Gems: Beyond Petra",
    excerpt:
      "Explore Jordan's lesser-known but equally stunning destinations beyond the famous Petra.",
    content: "While Petra is Jordan's most famous attraction...",
    author: "Jordan Travel Guide",
    publishDate: "2024-01-12",
    image:
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop",
    tags: ["Jordan", "Petra", "Hidden Gems", "Middle East"],
    readTime: 7,
    featured: false,
  },
  {
    id: "b5",
    title: "Best Time to Visit Egypt: Seasonal Guide",
    excerpt:
      "Learn about the best times to visit Egypt based on weather, crowds, and special events.",
    content: "Egypt's climate varies significantly throughout the year...",
    author: "Climate Expert Dr. Omar",
    publishDate: "2024-01-10",
    image:
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?w=800&h=600&fit=crop",
    tags: ["Egypt", "Travel Planning", "Weather", "Seasons"],
    readTime: 6,
    featured: false,
  },
];
